export const Svg_126 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M30.625 45.208h8.75v-7.291h7.292v-8.75h-7.292v-7.292h-8.75v7.292h-7.292v8.75h7.292v7.291ZM35 64.167c-6.757-1.702-12.335-5.578-16.734-11.63-4.4-6.053-6.6-12.773-6.6-20.162V14.583L35 5.833l23.333 8.75v17.792c0 7.389-2.2 14.11-6.599 20.161-4.399 6.053-9.977 9.93-16.734 11.63Zm0-6.125c5.056-1.605 9.236-4.813 12.542-9.625 3.305-4.813 4.958-10.16 4.958-16.042V18.594L35 12.03l-17.5 6.563v13.781c0 5.882 1.653 11.23 4.958 16.042 3.306 4.812 7.486 8.02 12.542 9.625Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={22.458}
        x2={52.435}
        y1={14.583}
        y2={53.395}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)